export default __webpack_public_path__ + "static/media/mobile-hero-image.61104652.png";